import Utils from '../utils/utils';
import ajax from '../utils/ajax';
import WidgetStyles from './widget.css';
import AppStyles from './app.css';
import AppContent from './app-content.html';
import config from '../../config';
import clientId from '../utils/client-id';
import LocalData from '../utils/local-data';

let cid = clientId;

const eventListeners = {};
 
const Widget = {
  emit(...args) {
    const events = args[0].split(' ');
    const data = args.slice(1, args.length);
    events.forEach((eventName) => {
      if (!eventListeners[eventName]) return;
      eventListeners[eventName].forEach((eventCallback) => {
        eventCallback(...data);
      });
    });
  },
  on(events, handler) {
    if (typeof handler !== 'function') return;
    events.split(' ').forEach((event) => {
      if (!eventListeners[event]) eventListeners[event] = [];
      eventListeners[event].push(handler);
    });
  },
  themeColor: '#825ae3',
  fixViewport() {
    let viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.setAttribute('name', 'viewport');
      viewport.setAttribute('content', 'initial-scale=1');
      document.querySelector('head').appendChild(viewport);
      return;
    }
  },
  addStyles() {
    const styleEl = document.createElement('style');
    styleEl.innerHTML = WidgetStyles.replace(/\$themeColor/g, Widget.themeColor).replace(/\$fontsPath/g, config.fontsPath);
    document.head.appendChild(styleEl);
  },
  addLayout() {
    // iFrame
    Widget.iframe = document.createElement('iframe');
    Widget.iframe.scrolling = 'no';
    Widget.iframe.allowfullscreen = true;

    // iFrame Wrap
    Widget.frame = document.createElement('div');
    Widget.frame.id = 'brief-widget-frame';
    Widget.frame.appendChild(Widget.iframe);

    // Container
    Widget.container = document.createElement('div');
    Widget.container.id = 'brief-widget-container';
    Widget.container.appendChild(Widget.frame);
    Widget.container.className += `brief-widget-container-${Widget.settings.position}`;

    // Notifications
    Widget.notificationsIframe = document.createElement('iframe');
    Widget.notificationsIframe.scrolling = 'no';

    Widget.notificationsFrame = document.createElement('div');
    Widget.notificationsFrame.id = 'brief-widget-notifications';
    Widget.notificationsFrame.appendChild(Widget.notificationsIframe);
    Widget.notificationsFrame.className += `brief-widget-notifications-${Widget.settings.position}`;

    // Opener
    if (window.BriefElementId) {
      Widget.launcher = document.getElementById(window.BriefElementId || 'brief-chat-button');
      const unreadElement = document.getElementById(window.window.BriefUnreadId || 'brief-unread-count');
      if (unreadElement) {
        if (Widget.settings.unread > 0) {
          unreadElement.innerHTML = Widget.settings.unread;
          unreadElement.style.visibility = 'visible';
        } else {
          unreadElement.style.visibility = 'hidden';
        }
      }
      Widget.frame.className += 'no-button';
    } else {
      Widget.launcher = document.createElement('div');
      Widget.launcher.id = 'brief-widget-launcher';
      Widget.launcher.className += `brief-widget-launcher-${Widget.settings.position}`;
      if (Widget.settings.unread > 0) {
        Widget.launcher.innerHTML = `<div id="brief-widget-launcher-unread">${Widget.settings.unread}</div>`;
      }
    }

    document.body.appendChild(Widget.notificationsFrame);
    document.body.appendChild(Widget.container);
    if (!window.BriefElementId) {
      document.body.appendChild(Widget.launcher);
    }
  },
  constructAppIframe() {
    const w = Widget.iframe.contentWindow;
    const d = Widget.iframe.contentWindow.document;
    d.open('text/html', 'replace');
    d.write(AppContent);
    d.close();

    const styles = d.createElement('style');
    styles.innerHTML = AppStyles.replace(/\$themeColor/g, Widget.themeColor).replace(/\$fontsPath/g, config.fontsPath);

    d.head.appendChild(styles);

    // Settings script
    w.settings = Widget.settings;
    w.widgetId = Widget.id;
    w.widget = Widget;
    w.briefUser = Widget.user;

    const script = d.createElement('script');
    script.onload = () => {
      Widget.app = Widget.iframe.contentWindow.BriefChatApp;
      Widget.onload();
      Widget.emit('appLoaded');
    };
    script.src = config.appScript;
    d.head.appendChild(script);
  },
  constructNotificationsIframe() {
    const d = Widget.notificationsIframe.contentWindow.document;
    d.body.className += 'notifications-body';
    d.body.innerHTML = `
      <div class="notifications">
        <div class="notifications-close"><i class="icon brief-icons">close</i></div>
        <div class="notifications-items"></div>
        <div class="notifications-input">
          <input type="text" placeholder="Message" ${Utils.isTouch ? 'readonly' : ''}/>
          <div class="notifications-input-button"><i class="icon brief-icons">send</i></div>
        </div>
      </div>
      `;
    Widget.notificationsContainer = d.body.querySelector('.notifications');
    Widget.notificationsItems = d.body.querySelector('.notifications-items');
    Widget.notificationsCloseButton = d.body.querySelector('.notifications-close');
    if (Utils.isTouch) d.body.className += ' touch';
    Widget.notificationsInput = d.body.querySelector('.notifications-input input');

    Widget.notificationsInput.addEventListener(Utils.isTouch ? 'touchstart' : 'focus', () => {
      Widget.open(Widget.notificationConversationId, true);
    }, false);

    Widget.notificationsCloseButton.addEventListener('click', Widget.notificationsClose, false);
    d.body.addEventListener('mouseenter', () => {
      Widget.notificationsCloseButton.className += ' notifications-close-visible';
    }, false);
    d.body.addEventListener('mouseleave', () => {
      const newClassName = Widget.notificationsCloseButton.className.replace(' notifications-close-visible', '');
      Widget.notificationsCloseButton.className = newClassName;
    }, false);

    const styles = d.createElement('style');
    styles.innerHTML = AppStyles.replace(/\$themeColor/g, Widget.themeColor).replace(/\$fontsPath/g, config.fontsPath);
    d.head.appendChild(styles);
  },
  isFullScreen() {
    return window.innerWidth <= 450 || window.innerHeight <= 420;
  },
  checkFullScreen() {
    const html = Widget.iframe.contentWindow.document.querySelector('html');
    if (Widget.isFullScreen()) {
      if (html.className.indexOf('fullscreen') < 0) {
        html.className += ' fullscreen';
      }
    } else {
      html.className = html.className.replace(' fullscreen', '');
    }
  },
  attachEvents() {
    window.addEventListener('resize', Widget.checkFullScreen, false);
    Widget.launcher.addEventListener('click', Widget.toggle, false);
  },
  getLanguage() {
    const language = navigator.language;
    if (!language) {
      return '';
    }
    if (language.indexOf('-') < 0) {
      return language.toLowerCase();
    }
    return language.split('-')[0];
  },
  requestSettings(callback) {
    ajax.request({
      url: `${config.api}/widget/settings`,
      method: 'POST',
      type: 'POST',
      data: {
        widgetId: Widget.id,
        clientId: cid,
        lang: this.getLanguage(),
      },
      dataType: 'json',
      success(resp) {
        if (process.env.NODE_ENV === 'production') {
          if (resp && !resp.success) return;
        }
        Widget.settings = resp.data;
        if (Widget.settings.themeColor) {
          Widget.themeColor = Widget.settings.themeColor;
        }
        if(Widget.settings.invalidClientId)
        {
            LocalData.remove('clientId');
        }
        if (callback) callback(resp);
      },
    });
  },
  id: window.BriefWidgetId,
  widgetId: window.BriefWidgetId,
  user: window.BriefUser,
  opened: false,
  open(conversationId, focus) {
    clearTimeout(Widget.welcomeMessageTimeout);
    Widget.needsWelcomeMessage(false);
    if (Widget.opened) return;
    Widget.container.style.display = 'block';
    Widget.clientLeft = Widget.container.clientLeft;
    Widget.container.className += ' brief-widget-container-opened';
    Widget.launcher.className += ' brief-widget-launcher-opened';
    if (Utils.isTouch && Utils.isIOS && Widget.isFullScreen()) {
      document.body.className += ' brief-widget-active';
    }

    Widget.opened = true;
    if (Widget.app) {
      Widget.app.opened = true;
      Widget.app.$emit('open', conversationId, focus);
    } else {
      Widget.on('appLoaded', () => {
        Widget.app.opened = true;
        Widget.app.$emit('open', conversationId, focus);
      });
    }
    if (!window.BriefElementId) {
      Widget.launcher.innerHTML = '';
    } else {
      const widgetFrame = document.getElementById('brief-widget-frame');
      if (widgetFrame) {
        //widgetFrame.style.bottom = '15px';
      }
    }
    Widget.notificationConversationId = undefined;
    Widget.notificationsClose();
  },
  close() {
    if (!Widget.opened) return;
    if (Utils.isTouch && Utils.isIOS && Widget.isFullScreen()) {
      if (Widget.container.className.indexOf('brief-widget-container-opened') < 0) return;
    }
    document.body.className = document.body.className.replace(' brief-widget-active', '');
    Widget.container.className = Widget.container.className.replace(' brief-widget-container-opened', '');
    Widget.launcher.className = Widget.launcher.className.replace(' brief-widget-launcher-opened', '');
    Widget.opened = false;
    if (Widget.app) {
      Widget.app.opened = false;
      Widget.app.$emit('close');
    }
    setTimeout(() => {
      if (Widget.container.className.indexOf('brief-widget-container-opened') >= 0) return;
      Widget.container.style.display = 'none';
    }, 200);
  },
  toggle() {
    if (Widget.opened) Widget.close();
    else Widget.open();
  },
  notify(message = {}) {
    clearTimeout(Widget.welcomeMessageTimeout);
    Widget.notificationConversationId = message.conversationId;
    Widget.needsWelcomeMessage(false);
    let messageName = message.name ? message.name.split(' ')[0] : message.firstName;
    if (message.isTeamName) {
      messageName = message.name;
    }
    const file = message.files && message.files.length > 0 ? message.files[0] : null;
    Widget.notificationsItems.innerHTML = `
      <div class="notification">
        ${message.photo ? `<div class="notification-avatar" style="background-image:url(${Widget.settings.photoPath}${message.photo}?h=68&404=avatar&autorotate=true)"></div><div class="notification-avatar-shadow"></div>` : ''}
        ${messageName ? `<div class="notification-name">${messageName}</div>` : ''}
        <div class="notification-text">${message.text.replace(/\n/g, '<br>')}</div>
        ${file ? `<img src="${Widget.settings.photoPath}${file.filename}" height="200px" />` : ''}
      </div>
    `;
    //Widget.notificationsItems.querySelector('.notification').addEventListener('click', () => {
      //Widget.notificationsClose();
      //Widget.open(Widget.notificationConversationId);
    //}, false);
    setTimeout(() => {
      if (Widget.notificationsContainer.offsetHeight) {
        Widget.notificationsFrame.style.height = `${Widget.notificationsContainer.offsetHeight}px`;
        if (file) {
          Widget.notificationsFrame.style.height = `${Widget.notificationsContainer.offsetHeight + 200}px`;
        }
      }
    }, 500);
    Widget.notificationsOpen();
  },
  notificationsOpen() {
    Widget.clientLeft = Widget.notificationsFrame.clientLeft;
    //Widget.notificationsFrame.style.display = 'block';
    Widget.notificationsFrame.className += ' brief-widget-notifications-opened';
  },
  notificationsClose() {
    if (Widget.notificationsFrame.className.indexOf('brief-widget-notifications-opened') < 0) return;
    Widget.notificationsFrame.className = Widget.notificationsFrame.className.replace(' brief-widget-notifications-opened', '');
    //setTimeout(() => {
      //if (Widget.notificationsFrame.className.indexOf('brief-widget-notifications-opened') >= 0) return;
      //Widget.notificationsFrame.style.display = 'none';
    //}, 200);
  },
  welcomeMessageTimeout: null,
  welcomeMessageShown: false,
  needsWelcomeMessage(set) {
    if (typeof set === 'undefined') {
      // Get informartion
      let needs = true;
      try {
        if (LocalData.get('welcomeMessageShown') || Widget.welcomeMessageShown || LocalData.get('widgetUsed')) needs = false;
      } catch (e) {
        // No LS Support
      }
      return needs;
    }
    // Set shown flag
    if (set === false) {
      Widget.welcomeMessageShown = true;
      LocalData.set('welcomeMessageShown', true);
    } else {
      Widget.welcomeMessageShown = false;
      LocalData.remove('welcomeMessageShown');
    }
    return true;
  },
  showWelcomeMessage() {
    if (!Widget.settings || !Widget.settings.welcomeMessage) return;
    if (!Widget.needsWelcomeMessage()) return;
    let name;
    let photo;
    let isTeamName;
    if (Widget.settings.onlineUsers.length) {
      name = Widget.settings.onlineUsers[0].firstName;
      photo = Widget.settings.onlineUsers[0].photo;
    } else if (Widget.settings.teamName) {
      name = Widget.settings.teamName;
      isTeamName = true;
    }
    Widget.notify({
      text: Widget.settings.welcomeMessage,
      name,
      photo,
      isTeamName,
    });
  },
  onload() {
    const timeoutSettings = Widget.settings ? Widget.settings.welcomeMessageTimeoutSeconds || 1 : 1;
    Widget.welcomeMessageTimeout = setTimeout(() => {
      if (!window.BriefElementId) {
        Widget.showWelcomeMessage();
      }
    }, timeoutSettings * 1000);
    const queryData = Widget.queryData;
    if (
      queryData.briefwidgetid === Widget.id &&
      queryData.briefclientid === cid &&
      queryData.briefconversationid &&
      !Widget.opened
    ) {
      Widget.open(queryData.briefconversationid);
    }
    else {
        const tempConversationId = LocalData.get('tempConversationId');
        if(tempConversationId){
            Widget.open(tempConversationId);
            LocalData.remove('tempConversationId');
        }
    }
  },
  // eslint-disable-next-line
    getQueryData() {
        const query = document.location.search;
        const queryData = {};
        Widget.queryData = queryData;
        if (!query || query.length === 0) return;
        query.split('?')[1].split('&').forEach((part) => {
            const parts = part.split('=');
            queryData[parts[0]] = parts[1];
        });
        if (queryData.briefwidgetid && queryData.briefclientid && queryData.briefconversationid) {
            cid = queryData.briefclientid;
            LocalData.set('clientId', queryData.briefclientid);
            LocalData.set('tempConversationId', queryData.briefconversationid);
        }
    },
  init() {
    Widget.getQueryData();
    Widget.requestSettings(() => {
      Widget.fixViewport();
      Widget.addStyles();
      Widget.addLayout();
      Widget.constructAppIframe();
      Widget.constructNotificationsIframe();
      Widget.attachEvents();
      Widget.checkFullScreen();
    });
  },
};

const BriefWidget = {
  open: Widget.open,
  close: Widget.close,
};

Widget.init();

export default BriefWidget;
